export default "__VITE_ASSET__CumUfCK8__"